"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _css = require("@emotion/css");
var _sideMenu = _interopRequireDefault(require("@amzn/meridian-tokens/component/side-menu"));
var _closeSmall = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/close-small"));
var _menu = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/menu"));
var _context = require("./context");
var _sideMenuLink = _interopRequireDefault(require("./side-menu-link"));
var _sideMenuTitle = _interopRequireDefault(require("./side-menu-title"));
var _sideMenuSpacer = _interopRequireDefault(require("./side-menu-spacer"));
var _sheet = _interopRequireDefault(require("../sheet"));
var _row = _interopRequireDefault(require("../row"));
var _button = _interopRequireDefault(require("../button"));
var _icon = _interopRequireDefault(require("../icon"));
var _theme = require("../theme");
var _listReset = _interopRequireDefault(require("./../_styles/list-reset"));
var _isElementOf = _interopRequireDefault(require("./../_utils/is-element-of"));
var _isElementOfAny = _interopRequireDefault(require("./../_utils/is-element-of-any"));
var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));
var _useUniqueId = _interopRequireDefault(require("../use-unique-id/use-unique-id"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SKINNY_COLLAPSED_WIDTH = 64;
var navStyles = function navStyles(t, _ref) {
  var width = _ref.width,
    minWidth = _ref.minWidth,
    maxWidth = _ref.maxWidth;
  return (0, _css.css)(_objectSpread(_objectSpread({}, t.typographyCss("link")), {}, {
    color: t("linkForegroundColorDefault"),
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth,
    // HACK: Safari randomly fails to paint the nav unless you add this...
    transform: "translateZ(0)"
  }));
};
var headerStyles = (0, _css.css)({
  flexShrink: 0
});
var bodyStyles = function bodyStyles(_ref2) {
  var useSkinnyBar = _ref2.useSkinnyBar;
  return (0, _css.css)(_listReset["default"], {
    alignSelf: useSkinnyBar ? "flex-end" : undefined,
    width: useSkinnyBar ? SKINNY_COLLAPSED_WIDTH : undefined,
    overflowX: useSkinnyBar ? "hidden" : undefined,
    flex: "auto"
  });
};
var footerStyles = function footerStyles(t) {
  return (0, _css.css)({
    flexShrink: 0,
    padding: t("footerSpacingInset")
  });
};
var titleWrapperStyles = function titleWrapperStyles(_ref3) {
  var useSkinnyBar = _ref3.useSkinnyBar;
  return (0, _css.css)({
    visibility: useSkinnyBar ? "hidden" : undefined
  });
};
var sheetStyles = function sheetStyles(t) {
  return (0, _css.css)({
    zIndex: t("elevation")
  });
};

// Gets the state ("open" or "close") for the side menu button
// as well as if it should show or not.
var getButtonState = function getButtonState(_ref4) {
  var open = _ref4.open,
    onOpen = _ref4.onOpen,
    onClose = _ref4.onClose;
  var onlyClose = onClose && !onOpen;
  var onlyOpen = onOpen && !onClose;
  var state = onlyClose ? "close" : onlyOpen ? "open" : open ? "close" : "open";
  var show = onlyOpen || onlyClose || open ? onClose : onOpen;
  return [state, show];
};

/* eslint-disable react/prop-types */
var SideMenuButton = function SideMenuButton(_ref5) {
  var open = _ref5.open,
    onOpen = _ref5.onOpen,
    onClose = _ref5.onClose,
    openLabel = _ref5.openLabel,
    closeLabel = _ref5.closeLabel,
    sideMenuId = _ref5.sideMenuId;
  var _getButtonState = getButtonState({
      open: open,
      onOpen: onOpen,
      onClose: onClose
    }),
    _getButtonState2 = (0, _slicedToArray2["default"])(_getButtonState, 2),
    state = _getButtonState2[0],
    show = _getButtonState2[1];
  var _ref6 = state === "close" ? [_closeSmall["default"], onClose, closeLabel] : [_menu["default"], onOpen, openLabel],
    _ref7 = (0, _slicedToArray2["default"])(_ref6, 3),
    iconTokens = _ref7[0],
    onClick = _ref7[1],
    label = _ref7[2];
  return show ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    "aria-expanded": open.toString(),
    "aria-controls": sideMenuId,
    onClick: onClick,
    size: "small",
    label: label
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: iconTokens
  })) : null;
};
/* eslint-enable react/prop-types */

/**
 * This component can be used to render a side navigation bar for your
 * application.
 */
var SideMenu = function SideMenu(props) {
  var t = (0, _theme.useTheme)(_sideMenu["default"], "sideMenu");
  var id = (0, _useUniqueId["default"])({
    override: props.id,
    prefix: "side-menu-"
  });
  var isTitle = (0, _react.useMemo)(function () {
    return (0, _isElementOf["default"])(props.titleComponent);
  }, [props.titleComponent]);
  var isLink = (0, _react.useMemo)(function () {
    return (0, _isElementOfAny["default"])(props.linkComponents);
  }, [props.linkComponents]);
  var isSpacer = (0, _react.useMemo)(function () {
    return (0, _isElementOf["default"])(_sideMenuSpacer["default"]);
  }, []);
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  var type = props.type;
  var backgroundColor = t("backgroundColor", props.backgroundColor);

  /**
   * Extracts all of the links and spacer components from a children object and returns them
   * as an array.
   */
  var getLinksWithSpacers = function getLinksWithSpacers(children, requireIcon) {
    return _react["default"].Children.toArray(children).filter(function (child) {
      // If we are requiring links to use an icon, filter out links that
      // don't have an `icon` prop set.
      var validLink = requireIcon ? child.props.icon : true;
      return isLink(child) && validLink || isSpacer(child);
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_sheet["default"], (0, _extends2["default"])({}, passThroughProps, {
    open: props.open,
    type: props.type === "overlay" ? "overlay" : "push",
    side: "start",
    closedSize: type === "skinny" ? SKINNY_COLLAPSED_WIDTH : 0,
    backgroundColor: backgroundColor,
    motionDuration: parseInt(t("motionExpandDuration")),
    motionFunction: t("motionExpandFunction"),
    className: sheetStyles(t),
    spacingInset: "none",
    onClose: props.onClose
  }), function (_ref8) {
    var expanderState = _ref8.expanderState;
    var useSkinnyBar = expanderState === "exited" && type === "skinny";
    // Pull out the title and footer children
    var childrenArray = _react["default"].Children.toArray(props.children);
    var title = childrenArray.filter(isTitle)[0] || /*#__PURE__*/_react["default"].createElement("span", null);
    var footerChildren = childrenArray.filter(function (child) {
      return !isTitle(child) && !isLink(child) && !isSpacer(child);
    });
    // Pull out all the link children with spacers.
    var linksWithSpacers = getLinksWithSpacers(props.children, useSkinnyBar).map(function (child) {
      return isLink(child) ? /*#__PURE__*/_react["default"].cloneElement(child, {
        linkComponents: child.props.linkComponents || props.linkComponents
      }) : child;
    });
    // This is true if the side menu's links contain more links nested inside
    // of them. When we are using icon labels, however, always use false.
    var withGrandchildren = useSkinnyBar ? false : linksWithSpacers.filter(function (link) {
      return getLinksWithSpacers(link.props.children).length > 0;
    }).length > 0;
    return /*#__PURE__*/_react["default"].createElement(_context.Provider, {
      value: {
        siblingsWithChildren: withGrandchildren,
        useIconLabel: useSkinnyBar,
        sideMenuOpen: props.open,
        id: id,
        t: t
      }
    }, /*#__PURE__*/_react["default"].createElement("nav", {
      className: navStyles(t, props),
      "aria-labelledby": "".concat(id, "-title"),
      id: id
    }, /*#__PURE__*/_react["default"].createElement(_row["default"], {
      spacingInset: "400",
      spacing: "400",
      alignmentVertical: "top",
      alignmentHorizontal: "justify",
      className: headerStyles
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: titleWrapperStyles({
        useSkinnyBar: useSkinnyBar
      })
    }, title), /*#__PURE__*/_react["default"].createElement(SideMenuButton, {
      open: props.open,
      onOpen: props.onOpen,
      onClose: props.onClose,
      openLabel: props.openLabel,
      closeLabel: props.closeLabel,
      sideMenuId: id
    })), /*#__PURE__*/_react["default"].createElement("ul", {
      className: bodyStyles({
        useSkinnyBar: useSkinnyBar
      })
    }, linksWithSpacers), useSkinnyBar ? null : /*#__PURE__*/_react["default"].createElement("div", {
      className: footerStyles(t)
    }, footerChildren)));
  });
};
SideMenu.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Provide the side menu title, links, and footer elements here. The element
   * matching the component specified by the "titleComponent" prop is treated
   * as the title, any elements matching the components specified by the
   * "linkComponents" prop are treated as the navigation links, and all other
   * elements are placed in the side menu's footer.
   */
  children: _propTypes["default"].node.isRequired,
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   */
  "aria-*": _propTypes["default"].string,
  /**
   * The side menu's background color.
   */
  backgroundColor: _propTypes["default"].oneOf(["surface", "principal", "highlight", "subdued"]),
  /**
   * Provide an accessible label for the close button.
   */
  closeLabel: _propTypes["default"].string,
  /**
   * All props starting with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,
  /**
   * Sets an `id` attribute on the component's nav element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,
  /**
   * The component or components that will render each SideMenu link. Defaults
   * to SideMenuLink.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  linkComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),
  /**
   * Use this to apply a custom maximum width.
   *
   * NOTE: The "%" percentage unit is not supported (if you need a percentage
   * of the viewport try using the "vw" unit).
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /**
   * Use this to apply a minimum width.
   *
   * NOTE: The "%" percentage unit is not supported (if you need a percentage
   * of the viewport try using the "vw" unit).
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /**
   * Determines whether the side menu is open or collapsed.
   */
  open: _propTypes["default"].bool,
  /**
   * Provide an accessible label for the open menu button.
   */
  openLabel: _propTypes["default"].string,
  /**
   * The component that will render the title (or logo). Defaults to
   * SideMenuTitle.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  titleComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  /**
   * An `overlay` side menu will overlay the application when opened.
   * This feature is intended for mobile use. IMPORTANT: an `onClose` method
   * is required when type is set is set to `"overlay"`. `onClose` will be
   * called when the "x" close button or scrim (semi-transparent overlay
   * that covers the application behind the side menu) is clicked.
   *
   * Setting to `skinny` will cause the side menu to, when closed, collapse into
   * a skinny bar. Be sure to pass a function to `"onOpen"` to render the "≡"
   * menu button at the top of the menu when collapsed. Use in conjunction with
   * the `icon` for `SideMenuLink` to render links as an icon when collapsed.
   */
  type: _propTypes["default"].oneOf(["default", "skinny", "overlay"]),
  /**
   * By default the SideMenu width will adjust to fit its content. Use this to
   * fix the width.
   *
   * Set the width using a number (which will be treated as pixels) or a
   * string containing any valid CSS dimension *except* for "%" percentage
   * widths. If you need a percentage of the viewport try using the "vw" unit.
   *
   * Note that a default maxWidth is set, if you choose a width greater than that
   * you'll need to manually clear the maxWidth prop.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /**
   * Pass a function here in order to render an "x" close button in the top
   * right of the side menu. The function will be called when the button is
   * clicked.
   */
  onClose: _propTypes["default"].func,
  /**
   * If set the side menu will, when collapsed, transform to a "skinny" nav
   * bar with a "≡" menu button. The function will be called when the button
   * is clicked. NOTICE: be sure to set `type` to `"skinny"`.
   */
  onOpen: _propTypes["default"].func
} : {};
SideMenu.defaultProps = {
  open: true,
  closeLabel: "Close menu",
  openLabel: "Menu",
  titleComponent: _sideMenuTitle["default"],
  linkComponents: [_sideMenuLink["default"]],
  maxWidth: 340,
  type: "default"
};
var _default = SideMenu;
exports["default"] = _default;